/* eslint-disable prettier/prettier */
import React, { useCallback, useState, useEffect } from 'react';
import { VideoCover } from './VideoCover';
import styles from './IFrameContainer.scss';
export const IFrameContainer = props => {
  const [size, setSize] = useState(null);
  const [showPlayer, setShowPlayer] = useState(props.playing || false);
  const setContainerRef = useCallback(div => {
    if (!div) {
      return;
    }
    const height = Math.ceil(div.clientHeight);
    const width = Math.ceil(height / 9 * 16);
    setSize({
      width,
      height
    });
  }, []);
  const handlePlayClick = useCallback(() => {
    setShowPlayer(true);
  }, []);

  // Update showPlayer when playing prop changes
  useEffect(() => {
    if (props.playing) {
      setShowPlayer(true);
    }
  }, [props.playing]);
  return /*#__PURE__*/React.createElement("div", {
    ref: setContainerRef,
    className: styles.container,
    onClick: handlePlayClick
  }, size ? /*#__PURE__*/React.createElement("div", {
    className: `${styles.playerWrapper} ${props.poster && !showPlayer ? styles.hidden : ''}`
  }, props.children(size)) : null, props.poster && !showPlayer && /*#__PURE__*/React.createElement("div", {
    className: styles.overlay
  }, /*#__PURE__*/React.createElement(VideoCover, {
    poster: props.poster,
    onPlayClick: handlePlayClick,
    dataHook: props.dataHook || 'iframe-video-cover'
  })));
};
//# sourceMappingURL=IFrameContainer.js.map